export default __webpack_public_path__ + "static/media/sailing-ship.bbaca0e6.png";